export default "__VITE_ASSET__G5tga1eQ__"